import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import React, { useEffect } from 'react';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';
import PropTypes from 'prop-types';

// This is a component that adds a fake loader with a set timeout and then will auto-submit the
// resource and move on to the next screen
export const InsightLoadingLottie = ({
  relationship,
  onNext,
  lottieDuration,
  setLoading,
}) => {
  const { isContentShowing } = useLottieLoadingContext();

  useEffect(() => {
    let timerId;
    if (isContentShowing) {
      setLoading(true);
      timerId = setTimeout(() => {
        // auto-submit the resource after the timeout completes
        onNext();
        setLoading(false);
      }, lottieDuration);
    }
    return () => clearTimeout(timerId);
  }, [isContentShowing]);

  return (
    <LottieRel relationship={relationship} width={'100%'} loop={false} />
  );
};

InsightLoadingLottie.defaultProps = {
  lottieDuration: 10000,
};

InsightLoadingLottie.propTypes = {
  onNext: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  relationship: PropTypes.object.isRequired,
  lottieDuration: PropTypes.number,
};
